export const translations = {
  en: {
    nav: { wordmark: "MISE", join: "Join" },
    hero: {
      eyebrow: "Early Access — For Hospitality Professionals",
      line1: "What if your work",
      line2: "became your",
      line3: "professional",
      line3accent: "reputation?",
      cta: "Join Our Early Access Community",
      scroll: "Scroll",
    },
    marquee: "ELEVATE YOUR CRAFT — EXCLUSIVE EARLY ACCESS — FOR HOSPITALITY PROFESSIONALS — ",
    rolesMarquee: "CHEF — COOK — PASTRY CHEF — SERVER — BARTENDER — BARISTA — HOST — STEWARD — FOOD RUNNER — BUSSER — SOMMELIER — RESTAURANT MANAGER — HOTEL PROFESSIONAL — ",
    problem: {
      label: "The Problem",
      chapters: [
        { n: "01", text: "Every shift builds experience." },
        { n: "02", text: "Every restaurant shapes your career." },
        { n: "03", text: "Yet too much of that work goes unrecorded and unnoticed." },
      ],
      closing: "We're building something different.",
    },
    benefits: {
      label: "Your Professional Portfolio",
      items: [
        { n: "01", title: "Your craft, recorded", body: "Every service, every station, every role — captured as a lasting record of the work you actually did." },
        { n: "02", title: "A reputation that grows with you", body: "Your professional story builds over time and is recognized across the hospitality community." },
        { n: "03", title: "Recognition you own", body: "The experience you earn stays yours, verified, recognized, and always in your hands." },
      ],
    },
    milestone: {
      leftLabel: "Next Milestone",
      leftHeading: "Pitch Week — September 2026",
      leftBody: "Wingman Ventures AI is approaching Pitch Week with LvlUp Ventures and its ecosystem of partners. Investor access to company materials will open beginning September 3.",
      investorLabel: "Investor Access",
      investorStatus: "Opening September 3",
      rightLabel: "Company Update",
      rightHeading: "Strategic Partnership",
      partnership: "Wingman Ventures AI × SHOPLINE",
      rightBody: "Our partnership with SHOPLINE marks another step in expanding Wingman's technology and distribution ecosystem.",
      trademark: "SHOPLINE is a trademark of its respective owner.",
    },
    finalCta: {
      label: "Early Access",
      heading: "Join our",
      headingAccent: "Early Access community.",
      sub: "Your reputation builds community. And being part of it comes with benefits. The stronger the community becomes, the more it can create for everyone. Something as simple as a complimentary coffee can be just the beginning. Join the Waitlist and be part of it from the beginning.",
    },
    form: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      role: "Hospitality role",
      rolePlaceholder: "Select your role",
      company: "Restaurant / Company",
      companyOptional: "optional",
      submit: "Join Our Early Access Community",
      submitting: "Reserving your place…",
      roles: ["Chef", "Sous Chef", "Sommelier", "Restaurant Manager", "Front of House", "Bartender", "Owner", "Other"],
      sourceLabel: "How did you hear about us?",
      sourceOptional: "optional",
      sourcePlaceholder: "Select an option",
      sourceOptions: [
        { value: "Handinator Delivery", label: "Handinator Delivery" },
        { value: "Invitation Card", label: "Invitation Card" },
        { value: "Restaurant", label: "Restaurant" },
        { value: "Friend or Colleague", label: "Friend or Colleague" },
        { value: "Instagram", label: "Instagram" },
        { value: "Facebook", label: "Facebook" },
        { value: "LinkedIn", label: "LinkedIn" },
        { value: "Reddit", label: "Reddit" },
        { value: "YouTube", label: "YouTube" },
        { value: "TikTok", label: "TikTok" },
        { value: "Google Search", label: "Google Search" },
        { value: "Other Website", label: "Other Website" },
        { value: "Other", label: "Other" },
      ],
      sourceDetailPrompts: {
        "Restaurant": "Which restaurant?",
        "Friend or Colleague": "Who invited you?",
        "Other Website": "Which website?",
        "Other": "Tell us more",
      },
      successTitle: "You're on the list.",
      successBody: "Welcome to the first circle. We'll be in touch soon with your early access.",
      again: "Register someone else",
      errorRequired: "Please complete all required fields.",
      errorEmail: "Please enter a valid email.",
      errorGeneric: "Something went wrong. Please try again.",
    },
    footer: { rights: "All rights reserved.", admin: "Admin", backedBy: "A Wingman Ventures AI Company" },
  },
  es: {
    nav: { wordmark: "MISE", join: "Unirse" },
    hero: {
      eyebrow: "Acceso Anticipado — Para Profesionales de la Hostelería",
      line1: "¿Y si tu trabajo",
      line2: "se convirtiera en tu",
      line3: "reputación",
      line3accent: "profesional?",
      cta: "Únete a Nuestra Comunidad de Acceso Anticipado",
      scroll: "Desliza",
    },
    marquee: "ELEVA TU OFICIO — ACCESO ANTICIPADO EXCLUSIVO — PARA PROFESIONALES DE LA HOSTELERÍA — ",
    rolesMarquee: "CHEF — COCINERO — PASTELERO — CAMARERO — BARTENDER — BARISTA — ANFITRIÓN — STEWARD — CORREDOR DE COMIDA — AYUDANTE — SUMILLER — GERENTE DE RESTAURANTE — PROFESIONAL DE HOTEL — ",
    problem: {
      label: "El Problema",
      chapters: [
        { n: "01", text: "Cada turno construye experiencia." },
        { n: "02", text: "Cada restaurante moldea tu carrera." },
        { n: "03", text: "Sin embargo, demasiado de ese trabajo queda sin registrar y pasa desapercibido." },
      ],
      closing: "Estamos construyendo algo diferente.",
    },
    benefits: {
      label: "Tu Portafolio Profesional",
      items: [
        { n: "01", title: "Tu oficio, registrado", body: "Cada servicio, cada estación, cada rol — capturado como un registro duradero del trabajo que realmente hiciste." },
        { n: "02", title: "Una reputación que crece contigo", body: "Tu historia profesional se construye con el tiempo y es reconocida en toda la comunidad de hospitalidad." },
        { n: "03", title: "Reconocimiento que es tuyo", body: "La experiencia que ganas sigue siendo tuya, verificada, reconocida y siempre en tus manos." },
      ],
    },
    milestone: {
      leftLabel: "Próximo Hito",
      leftHeading: "Pitch Week — Septiembre 2026",
      leftBody: "Wingman Ventures AI se acerca a la Pitch Week con LvlUp Ventures y su ecosistema de socios. El acceso de inversores a los materiales de la compañía se abrirá a partir del 3 de septiembre.",
      investorLabel: "Acceso para Inversores",
      investorStatus: "Disponible el 3 de septiembre",
      rightLabel: "Novedad de la Compañía",
      rightHeading: "Alianza Estratégica",
      partnership: "Wingman Ventures AI × SHOPLINE",
      rightBody: "Nuestra alianza con SHOPLINE marca otro paso en la expansión del ecosistema de tecnología y distribución de Wingman.",
      trademark: "SHOPLINE es una marca de su respectivo propietario.",
    },
    finalCta: {
      label: "Acceso Anticipado",
      heading: "Únete a nuestra",
      headingAccent: "comunidad de acceso anticipado.",
      sub: "Tu reputación construye comunidad. Y ser parte de ella trae beneficios. Cuanto más fuerte se vuelve la comunidad, más puede crear para todos. Algo tan simple como un café de cortesía puede ser solo el comienzo. Únete al Waitlist y sé parte desde el principio.",
    },
    form: {
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo electrónico",
      role: "Rol en hostelería",
      rolePlaceholder: "Selecciona tu rol",
      company: "Restaurante / Empresa",
      companyOptional: "opcional",
      submit: "Únete a la Comunidad de Acceso Anticipado",
      submitting: "Reservando tu lugar…",
      roles: ["Chef", "Segundo de Cocina", "Sumiller", "Gerente de Restaurante", "Sala", "Bartender", "Propietario", "Otro"],
      sourceLabel: "¿Cómo nos conociste?",
      sourceOptional: "opcional",
      sourcePlaceholder: "Selecciona una opción",
      sourceOptions: [
        { value: "Handinator Delivery", label: "Entrega Handinator" },
        { value: "Invitation Card", label: "Tarjeta de invitación" },
        { value: "Restaurant", label: "Restaurante" },
        { value: "Friend or Colleague", label: "Amigo o colega" },
        { value: "Instagram", label: "Instagram" },
        { value: "Facebook", label: "Facebook" },
        { value: "LinkedIn", label: "LinkedIn" },
        { value: "Reddit", label: "Reddit" },
        { value: "YouTube", label: "YouTube" },
        { value: "TikTok", label: "TikTok" },
        { value: "Google Search", label: "Búsqueda en Google" },
        { value: "Other Website", label: "Otro sitio web" },
        { value: "Other", label: "Otro" },
      ],
      sourceDetailPrompts: {
        "Restaurant": "¿Qué restaurante?",
        "Friend or Colleague": "¿Quién te invitó?",
        "Other Website": "¿Qué sitio web?",
        "Other": "Cuéntanos más",
      },
      successTitle: "Estás en la lista.",
      successBody: "Bienvenido al primer círculo. Pronto te contactaremos con tu acceso anticipado.",
      again: "Registrar a otra persona",
      errorRequired: "Por favor completa todos los campos obligatorios.",
      errorEmail: "Por favor introduce un correo válido.",
      errorGeneric: "Algo salió mal. Inténtalo de nuevo.",
    },
    footer: { rights: "Todos los derechos reservados.", admin: "Admin", backedBy: "Una empresa de Wingman Ventures AI" },
  },
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/13343442/pexels-photo-13343442.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  problem: "https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  problemCarousel: [
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/d26e7e24704d870a9e002061b745cd6a9c5cd62f47137464519c8c1eac851950.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/3b0a47b3eaa653a40f52967f8e2bc2163cb95962091f71ae9abd9d8b9bf0f367.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/8292e3fc8705e2d80ad63a852208c482eaa5321fa6c193c32bc2fdb0baa7e422.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/ed431dbab47b72cb278beb338a36150b3cceeab448819bff84fb97d59c07305e.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/a34b63f8e48b5112c76e7829e5c05014c6313332c671591beaf9366b90945882.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/42032e721490f46b27bcfd8a1791b2b2c519f94f0d43f8683a241966e2e57336.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/75ef5659b437151bec0bff62711ca0300fd6268283d1522fffeaaf0b01a3cf21.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/3636750807867c770bb73174cddf1857060bd5b62a25118d70db42529c4558d4.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/7d92df3ba20aeffa65fc3b1948366c4b0c1deb642e1b6722bf59eb4996e31a90.jpeg",
    "https://static.prod-images.emergentagent.com/jobs/bf01aff7-306d-417f-ad7e-ce3ff3fa6442/images/e6feba003d1919357059e600de336772a66040b3bd340681804060ed05f4f037.jpeg",
  ],
  benefit1: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  benefit2: "https://images.pexels.com/photos/10855223/pexels-photo-10855223.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000",
  finalCta: "https://images.pexels.com/photos/12821625/pexels-photo-12821625.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
};
